import React, { useCallback } from 'react';
import { ButtonTertiary } from 'components';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

const IncorrectPartNumber = () => {
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);

  const setReviewRequested = useCallback(() => {
    setLookupState({
      ...currentLookupState,
      incorrectResult: { ...currentLookupState.selectedResult },
      selectedResult: null,
      incorrectPartNumber: true,
    });
  }, [currentLookupState, setLookupState]);

  return currentLookupState.incorrectPartNumber ? null : (
    <ButtonTertiary onClick={setReviewRequested}>
      Incorrect Part Number
    </ButtonTertiary>
  );
};

export default IncorrectPartNumber;
